import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  Modal,
  Grid,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Card,
  CardContent,
  Collapse,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect, useState } from "react";
import { getAllAppoint } from "./displayAdvanceApi";
import { convertDateToCustomFormat } from "../../../utils/commonUtils";

// Enhanced CounterSalesItemCard component with accordion
function CounterSalesItemCard({ item }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Card sx={{ mb: 2, boxShadow: 2 }}>
      <CardContent
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          backgroundColor: "#EEEEFF",
          py: 1,
          px: {xs:1, sm:4},
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Typography
            variant="subtitle1"
            fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
            fontWeight="500"
            color="#01008B"
          >
            {convertDateToCustomFormat(item?.createdDate?.split("T")[0])}
          </Typography>
          <Typography
            // variant="body2"
            color="text.primary"
            sx={{
              fontWeight: "500",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            ₹{item.amount?.toFixed(2) || "0.00"}
          </Typography>
        </Box>

        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setExpanded(!expanded);
          }}
          sx={{
            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s",
            ml: {sm:4, xs:1},
            color: "#000000",
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
          }}
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardContent>

      <Collapse in={expanded}>
        <CardContent sx={{ backgroundColor: "#EEEEFF" }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography
                variant="body2"
                fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
              >
                <Box
                  component="span"
                  sx={{
                    fontWeight: "500",
                    color: "#01008B",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Payment Mode:
                </Box>{" "}
                {item.paymentMethod || "N/A"}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography
                variant="body2"
                fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
              >
                <Box
                  component="span"
                  sx={{ fontWeight: "500", color: "#01008B" }}
                >
                  Transaction / Cheque No :
                </Box>{" "}
                {item.transactionDetails || "N/A"}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography
                variant="body2"
                fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
              >
                <Box
                  component="span"
                  sx={{ fontWeight: "500", color: "#01008B" }}
                >
                  Reason :
                </Box>{" "}
                {item.reason || "N/A"}
              </Typography>
            </Grid>
            {item.notes && (
              <Grid item xs={12}>
                <Typography
                  variant="body2"
                  fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                >
                  <strong>Notes:</strong> {item.notes}
                </Typography>
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Collapse>
    </Card>
  );
}

export default function DisplayAdvance({ open, setOpen, data, setOpenAn }) {
  const [detail, setDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setIsLoading(true);
      getAllAppoint(
        {
          buyerInfoId: data?.buyerInfoId,
          page: 1,
          pageSize: 1000,
          filter: "",
          search: "",
        },
        (response) => {
          setDetail(response);
          setIsLoading(false);
        },
        () => setIsLoading(false)
      );
    }
  }, [open, data]);

  const totalAmount = detail?.customerAdvanceDetail?.reduce(
    (sum, item) => sum + (item.amount || 0),
    0
  );

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="advance-details-modal"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "80%", md: "60%", lg: "50%" },
          maxHeight: "90vh",
          borderRadius: 2,
          boxShadow: 24,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            backgroundColor: "#C0BFFF",
            // bgcolor: "primary.main",
            color: "#01008B",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 1.5,
            px: 3,
          }}
        >
          <Typography
            variant="h6"
            component="h2"
            fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
          >
            Advance Payment
          </Typography>
          <IconButton edge="end" color="inherit" onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Divider />
        {/* Content */}
        <DialogContent sx={{ flex: 1, overflowY: "auto", p: 0 }}>
          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 200,
              }}
            >
              <Typography>Loading advance details...</Typography>
            </Box>
          ) : detail?.customerAdvanceDetail?.length > 0 ? (
            <Stack sx={{ p: 3 }}>
              {/* Employee Id */}
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={6} sm={4}>
                  <Typography
                    sx={{
                      color: "#01008B",
                      fontWeight: 600,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Employee Id:
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    {data?.id || "N/A"}
                  </Typography>
                </Grid>
              </Grid>

              {/* Employee Name */}
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={6} sm={4}>
                  <Typography
                    sx={{
                      color: "#01008B",
                      fontWeight: 600,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Employee Name:
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    {data?.name || "N/A"}
                  </Typography>
                </Grid>
              </Grid>

              {/* Balance Amount */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  // variant="h6"
                  sx={{
                    color: "#01008B",
                    fontWeight: "600",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Balance Amount:
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  ₹{totalAmount?.toFixed(2) || "0.00"}
                </Typography>
              </Box>

              <Divider
                sx={{
                  borderColor: "#4E4E4E",
                  borderBottomWidth: 1,
                  marginTop: 2,
                  marginBottom: 1,
                }}
              />

              {detail?.customerAdvanceDetail?.map((item, index) => (
                <CounterSalesItemCard key={`advance-${index}`} item={item} />
              ))}
            </Stack>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 150,
              }}
            >
              <Typography variant="body1" color="text.secondary">
                No advance payments found
              </Typography>
            </Box>
          )}
        </DialogContent>

        {/* Footer */}
        {/* <DialogActions
          sx={{
            borderTop: "1px solid rgba(0, 0, 0, 0.12)",
            p: 2,
            justifyContent: "space-between",
          }}
        > */}
        {/* <Button
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Close
          </Button> */}
        {/* </DialogActions> */}

        <Grid item xs={12}>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              type="submit"
              sx={{ width: "70%" }}
              variant="contained"
              onClick={() => {
                setOpenAn(true);
                setOpen(false);
              }}
            >
              Add Advance
            </Button>
          </DialogActions>
        </Grid>
      </Box>
    </Modal>
  );
}
